import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { SelectOption } from '../../shared/models/dropdowm.model';
import {
  AssessmentType,
  CreateAssessment,
  UpdateAssessment,
} from '../models/assessment.model';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    description?: string
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (description) params += `&description=${description}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/assessments?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/assessments/' + id
    );
  }

  getAllDropdown() {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/assessments/dropdown`
    );
  }

  create(data: CreateAssessment) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/assessments',
      data
    );
  }

  update(id: string, data: UpdateAssessment) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/assessments/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/assessments/${id}/status`,
      { isActive }
    );
  }

  getAssessmentTypeOptions(): SelectOption[] {
    return [
      { label: 'Automático', value: AssessmentType.Automatic },
      { label: 'Manual', value: AssessmentType.Manual },
    ];
  }
}
